const collaborators = ({ collaboration }) => {
    return collaboration.collaborators.filter(client => client.id != collaboration.hub.id)
}

const isBroken = ({ collaboration }) => !!collaboration.hub.connectionError

export const collaborationSelectors = { collaborators, isBroken }
